var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaburWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1541 1378",
    width: 1541,
    height: 1378,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m908.5 1152.9c-10.2-11.2-25.6-12.5-40.3-12.5-15.5 0-29.9 2.2-49.6 15.5 24.8-61.3 63.6-145 63.8-145.8l2.2-4.1-4.7 0.4c-0.3 0-23.8 2.3-71.1 13.6l-1.3 0.4-3.4 9.5-98.9 257.4c0 0-7.2 15.5-28.9 28.1-11.2 6.5-17.6 7.3-21.2 7.8-3.8 0.7-4.7-2.7-4.5-3.9 3-8 11.1-29.8 11.1-29.8 24-67.1 38.8-107.3 45.5-123.4l8.6-21.1h-65.4l-1.4 3c-7.5-4.6-16.4-7.2-26.6-7.2-14.4 0-33.1 8.3-58.6 26-26.3 18.4-49 39.8-67.2 63.8-22.8 30.2-34.4 60.4-34.4 89.7 0 13.6 2.9 25.4 9.1 35.2 5.3 8 15.5 17.8 34.6 17.8 24.8 0 48.8-9.3 71.3-27 1.9 6.2 5.5 11.7 12.8 16.7 9.3 6.7 22.4 10 27.7 10.3 5.4 0.2 24.4-0.8 41.9-9.6 14.6-7.6 23.5-17.2 31.8-29.8 4.3 10.3 9.8 18.9 16.8 25.8 8.9 9 20.4 13.6 33.5 13.6 37.6 0 76.7-18.4 116.8-54.7 43-38.9 64.9-81.4 64.9-125.8 0-15.6-4.9-29-14.9-39.9zm-88.3 134.1c-25.4 37.8-33.9 40-42.8 40.8-5.1 0.4-8.9-1.2-12.1-3.9-1.5-1.4-3.4-4.3-3.2-8.5 0 0 0.6-4.8 1.1-6.8 0.6-2 7.4-26.6 19-52.9 11.8-26.3 16.4-32.9 25.3-43.3 14.9-17.8 31.4-25.1 39.7-20.5 16.3 9-7.6 66.2-27 95.1zm-282.7 36.6c-13.3-6.6-2.9-35.6 20.2-77.3 18.9-33.8 37.6-50.9 55.2-50.9 2.3 0 4.7 0.3 7.8 3.8 2.8 3.2 4 6.3 4 9.6 0 9.3-5 28.4-28.8 65.5-21 32.8-47.6 54.5-58.4 49.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m1356.8 1193.6c0 12-3.8 22.6-11 31.5-7.9 9.5-19.1 14.5-32.5 14.5-2.6 0-3.6-1.1-4.2-2-1.9-3-0.3-7.2 2.3-13.5 2.8-6.8 5.5-14.9 3.2-19.7-2.1-4.5-9.4-10.2-16.8-9.5-8.7 1-13.6 3.2-13.6 3.2-6.2 2.5-12.9 5.2-25.6 24.3-11.1 16.9-22.4 39.9-33.6 68.3-7.9 19.6-16.1 43.9-24.4 71.7l-3.2 10.9h-67.9l10-29.8c-3.9 5.1-9.2 10.5-16.8 15.5-17.4 11.8-31.2 14.3-47.8 14.3-9.5 0-19.9-2.6-31.2-7.5-17.2-7.9-21-17.4-21-23.7l1.3-7.1 0.4-0.7c-29.5 25.8-54.8 39-77.3 39-12.1 0-22.3-4.2-30.9-12.4-8.8-8.1-15.1-18.5-14.3-31 1.1-15.2 68.4-185.7 68.4-185.7h70.2c0 0-55.4 141.6-65.7 168.9-0.9 1.6 0.8 3.9 2.7 4.3l3.4 0.4c13.6 0.1 24.4-10.9 36.5-24.3 12.9-14.8 26.5-36.8 40.1-65.1 8.7-17.8 18.7-42.2 30.8-74.4l3.8-9.8h68.8l-8.3 20.8c-9.3 23.7-21.7 58-35.7 99.4 0 0-15.8 46.6-19.2 56.6-1.1 2.8 3.7 5.4 3.7 5.4 10.5 4 22.6-0.6 31-5.4 3.8-2.4 13.2-9.3 20.5-17.2l52.1-156.2 68.2 0.2c0 0-2.8 7.5-4 11.6 12.5-9 24.8-14.5 36.9-14.5 15.9 0 28.5 4.8 37.3 14.4 9 9.2 13.4 20.7 13.4 34.3zm-869.4-3.3c-3.4 69.3-47.3 133.3-109.3 159-82.6 39.6-183 38-298.4-4.7l-2.2-0.8 0.7-2.2c24.4-81.6 104.8-348.3 116.9-353.9 37.8-17.4 77.1 37 78.8 39.3l0.9 1.1-86.5 219.6c-7.8 24.1-11.2 40.8 1.5 51.3 27.6 22.5 103.2 8.9 146.9-26.7 52.4-41.6 59.2-91.5 55.6-126.1-5.9-59.2-48.8-121.7-101.4-148.1-43.8-21.1-91.3-25.9-134-13.5-70 20.5-133.9 84.6-151.7 152.2l-5.1-0.9c22.5-152.1 156.2-185.7 231.7-181.4 63.7 3.4 129.5 43.1 130.2 43.4 83.6 45.2 129.5 115.3 125.4 192.4zm-433.4-720.3c12.5-9.1 38.8-20.7 67.5-12.5 28.2 7.9 45 37.4 48.8 45.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m106.8 515.9c26.2 7.4 53.9-6.8 63.5-13l-116.3-32.8c8.3 14.2 20.1 36.5 52.8 45.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m192.4 442.3c1.5-10.7 2.1-43.2-16.8-64.8-20.4-22.9-47.6-27.5-63.3-26.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m132.5 419.1c18.5 20 48.6 23.6 59.9 23.1l-80-90.7c0 16.2-3 42.5 20.1 67.6zm146.5 322.1c-11.9-4.5-56.9-12.6-85.6 7.5-29.3 20.5-38.4 55.3-40.1 73.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m238.6 814c29.8-19.4 40-57.9 40.4-72.7l-125.7 81c22.3 6.6 56.5 10.4 85.3-8.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m271.7 700.1c-7.4-11.7-46.6-53.3-90.4-57.1-42-3.6-79.6 14.4-96.1 28.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m170.9 727.1c43 7.9 86-15.1 100.8-27l-186.5-28.9c18.6 23 45 48.5 85.7 55.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m592.9 338.6c-4.9-11.3-28.8-52.5-67-67.1-42.1-16-81.6-4.4-99.6 6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m494.4 344.8c37.8 15.4 82 2.2 98.5-6.2l-166.6-61.1c12.9 24.6 32.2 52.7 68.1 67.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m374.9 800.6c0.9-13.4-0.2-43-19.5-65.1-20.8-23.8-48.4-28.6-63.3-29.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m313.1 772.7c19.2 22.3 49.7 29 61.8 27.8l-82.8-94.4c-1.3 16.3 2.6 45.3 21 66.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m384.5 683.1c-4.1-10.5-18.3-39.1-45-50.6-29.1-12.6-56-5.4-69.6 0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m314 682.6c29.1 14.4 60.1 6.8 70.5 0.5l-114.7-50.6c6.4 15 18.7 37.5 44.2 50.1zm-46.9-101.5c-7-8.7-30-33.6-61.2-35.8-33.3-2.5-57.1 17.3-68.1 28.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m202.8 609.7c29.7 1.5 56.2-20.4 64.3-28.6l-129.3-7.7c11.3 12 31.2 34.4 65 36.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m672.3 206.6c6.6-11.3 24-46.1 13.2-81-11.5-37.6-42.9-54.6-59.7-61.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m615 149.5c10.8 32.9 45 52.1 57.3 57.1l-46.5-142.9c-8.3 17.2-23.3 48.3-10.8 85.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m804.7 139.9c7.7-10 27.4-41.1 21.1-75-6.8-36.4-34.4-56.1-49.5-64.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m756.3 79.2c8 35.5 39.8 54.6 48.4 60.6l-28.4-139.6c-9.9 14-28 42.8-20 79z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m817.5 306.8c9.8-7.6 35.4-37.1 33.7-70-1.5-30.4-27.7-57.2-42.2-67.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m777.4 242.1c2.9 34.6 32 58 40.1 64.7l-8.5-137.1c-12.5 12-35 36.9-31.6 72.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m865 393.6c10.8-4.9 41.2-22.6 48.4-58.2 6.2-29.3-11.7-61-22.7-74z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m843.4 322.3c-5.3 31.4 15.9 62.9 21.6 71.3l25.7-132.2c-14.4 8.4-41.4 26.7-47.3 60.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m992.8 561.1c12.3 1.4 48.4 1.2 73.2-26.4 20.4-22.7 21-60.3 17.8-77.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1010 486.5c-20.4 25.2-18 64.2-17.2 74.6l91-103.9c-14.8-1.3-49.6-0.3-73.8 29.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1247.7 485.8c12.5 0.8 48.8-1.8 75.6-28.6 22.1-22.5 24.8-61.4 22.9-78.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1268.7 408.9c-23.3 26.3-21.6 65.9-21 76.8l98.5-107c-15.3-1.8-54.1 4.3-77.5 30.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1029.9 353.3c11.5-2.7 45.9-15.4 60.1-44.5 13.6-27.6 6.8-61-0.2-76.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1029.1 279.8c-14.5 29.6-2.4 63.9 0.8 73.4l59.9-120.7c-16.2 4.3-46.1 16.4-60.7 47.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1001.1 224.3c11.6-1.4 47.5-10.4 65.4-38.3 17-26.3 13.1-60.3 9.1-77z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1008.7 149.5c-17.8 28.5-10 64.9-7.6 74.8l74.7-115.2c-16.8 2.5-48.6 10.9-67.1 40.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1127.3 285.1c9.8 1.7 41 3.9 62.2-13.8 20.2-16.8 25.6-45.1 26.4-59.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1152 227c-21.2 18.2-24 49.5-24.7 58.1l88.6-73.4c-13.8-2.2-41.8-3.6-63.9 15.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1244.3 364.3c10.2-2.2 41.6-10.4 56.2-39.3 14.1-28.1 7-54.9 2.2-69.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1245.6 296.9c-13.6 26.5-4.9 56.5-1.3 67.4l58.4-108.6c-14.5 3.5-42.9 13.4-57.1 41.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1159.4 514.3c10.6-2.5 42.7-11.3 57.1-41.4 14-29.3 6.4-56.7 1.5-71.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1159.6 444.8c-13.6 27.8-4 58.3-0.2 69.5l58.6-112.8c-15.1 4-44.2 14.4-58.4 43.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1346.4 459.4c9.1 3.2 37.3 11.6 62.4-4.1 24.4-15.4 31.8-39.4 35-53z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1379.7 407.6c-23.6 14.2-30.7 41.6-33.1 51.8l97.3-57c-13-4-39.8-9.8-64.2 5.2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1302 557.9c8.1 5.5 34 20.7 63.5 12.7 29.5-8 40.7-30.5 49.2-43.5z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m1349.4 515c-27.4 8-42.3 33.3-47.4 42.9l112.8-30.8c-11.9-7.5-37.2-20.5-65.4-12.1zm51.1 64.8c7.9 8.8 33.6 33.8 70.1 33.3 37.4-0.3 57.7-21.4 69.8-36.2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1467.6 543.1c-33.8 1.5-58.3 26.9-67.1 36.7l139.9-3c-11.6-12.3-37.5-35.2-72.8-33.7z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1295.4 575.6c-0.8 10-0.3 40.9 21.5 62.6 21.2 21 48.2 19.9 62.4 20.1z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m1379.3 658.3l-83.9-82.7c11.1-0.1 41.4 0.2 62 19.9 21.5 20.5 22.5 48.9 21.9 62.8zm-249.8-86.6c5.7 13.3 14.8 37.3 3.8 65.2-11.5 28.6-40.3 40.3-49.9 43.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1078.9 614.6c-10.8 26.3 0 55.5 4.5 65.6l46.1-108.6c-13.4 4.7-39.3 15.4-50.6 43z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1232.9 722.9c4-10 7.6-42.8-8.1-65.4-16.2-23.4-42.9-30.2-56.9-32.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1177.7 692.5c15.5 21.5 44.5 28.5 55.2 30.4l-65-98.2c-4 13-7.6 43.6 9.8 67.8z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1112.3 226.6c11.2-2.3 44.8-13.6 60.5-42.3 14.8-27 8.5-60.5 3.2-76.5z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m1176 107.8l-63.7 118.8c-3.6-10.4-13.8-44.8 1.4-73.9 16.2-30.6 46.3-41.1 62.3-44.9zm-664-88.3c13.9 4.6 40 17.2 50.4 45.4 9.5 24.8 0.4 52.2-5.6 63.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m508.6 87.7c10.4 23.4 37.7 36.4 48.2 40.5l-45-108.8c-5.9 14.6-16.3 38.9-3.2 68.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m744.3 243.7c9.1-9.5 25.8-34 23.8-61.6-2.6-31.2-25.5-51.3-38.3-59.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m729.8 122.2l14.5 121.6c-9.6-7.1-33.8-27.7-37.6-54.2-4.9-33.1 12.7-54.6 23.1-67.4zm159.8-29.7c9.8 11.2 25.9 35.3 21 64.7-4.2 25.9-25.2 45-35.6 51.8z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m853.1 150c-2.5 25.5 14.7 50.3 21.9 59.1l14.6-116.6c-12.3 9.5-33.3 25.7-36.5 57.5z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m922.7 263c9.6-4 29.8-16.5 37.4-36.7 9.1-24.2-1.1-46.3-7.3-56.6z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m914 212.1c-5.7 20.4 4.2 42.8 8.7 50.9l30.2-93.3c-11.3 5.8-31.4 15.9-38.9 42.4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m952.8 391.1c10.9-4.2 33.2-17.2 41.7-39.5 10.2-26.6-0.9-51-7.5-62.4z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m943.3 335.7c-6.1 22.3 4.7 46.3 9.6 55.4l34.2-101.9c-12.8 6.3-35.5 17.6-43.8 46.5zm-374.8-74.4c4.1-29.8-2.7-57.3-19.3-77.2-20.8-25-57.5-32.5-73.5-31.2z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m494.8 229.3c17.4 19 38.3 29.8 73.7 32l-92.7-108.4c-1.9 15.4-2.6 52.4 19 76.4z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m659.6 494.5c12.3-26 16.3-54.9 6.4-77.6-14.5-33.9-46.1-46.5-61-49.9z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m600.1 442.5c10.2 22.4 27.8 39.8 59.5 52l-54.6-127.6c-6.4 13.7-17.6 47.6-4.9 75.6z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m953.1 144.4c24-9.6 43.3-24.7 51.6-46.2 10.2-26.6-1.3-59.8-9.4-71.8z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m943.1 73c-8.1 21.7-4 43 10 71.4l42.2-118c-14.6 4.4-42 20.1-52.2 46.6z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m746 413.2c15.7-25.1 25.5-55 19.3-78.7-10.2-40-44-57-58.6-63.1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m688.9 355.3c7.4 25.1 28.6 45.2 57.1 57.9l-39.3-141.8c-12.5 18-27.2 52.5-17.8 83.9zm352.7 69.7c31 12.2 67.5 13.5 93.6 1.6 42-19.4 55.2-62 61.3-78.5z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1097.2 349.3c-27 14.3-45.6 43-55.6 75.7l154.9-76.9c-22.9-9.2-62.8-17.8-99.3 1.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1151.1 607.2c31.2 8.7 67.7 6.6 92.1-7.1 39.1-21.8 48.9-62.1 53.1-78.9z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1198.4 531.3c-25 15.6-40.5 42.8-47.3 76l145.2-86.1c-23.3-6.2-65.2-10.2-97.9 10.1z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1364 778.3c8.8-34 3.8-67.1-10.8-88.8-22.7-34-62.2-43.1-78.5-46.2z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m1274.7 643.3l89.3 134.9c-31.8-6.4-59.9-19-75.8-41.1-22.7-31.2-20.8-70.2-13.5-93.8zm-678-444.6c14.5 5.3 42.9 21.1 54.8 52.7 8.3 22.1 4 50.8-9.3 75.2z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m596.7 198.7l45.5 127.9c-30.8-14.1-46.3-30.1-55-54.1-10.7-28.8 2.6-60.6 9.5-73.8zm-372.9 126c15.3-2.3 42.4 0.3 62.8 21.6 19.5 19.9 18.5 52.8 17.6 63.3z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m245.8 389.9c18.7 18.5 47.2 20.9 58.4 19.7l-80.4-85c-0.9 13.3-1.5 42.4 22 65.3zm190.9-46.2c-3.6-10.3-12.1-39.6-43.1-55.8-25.7-13.4-59.8-6.4-74.1 0.9z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m367.9 347.1c25.3 11.2 57.9 1.6 68.6-3.4l-117-54.9c4.9 13.2 16.6 44.5 48.4 58.3zm89.8-115.6c-0.6-12.8-3.6-47-35-77.2-23.6-22.6-55.9-22-71.8-18.9z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m351.2 135.4l106.5 96.1c-25.1 1.7-53.9-5.6-75.2-24.6-27.1-24.1-30.5-57.6-31.3-71.5zm-14.2 251.7c12.9-9.6 41.1-21.6 72.7-13.2 29.5 7.8 46.5 38.7 51.8 48.4z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m394.7 436.7c28.4 6.8 57.1-7.9 66.8-14.4l-124.6-35.2c6.8 12.1 22.5 41 57.8 49.6z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m579.3 471.3c-1.5-9.8-11.2-41.8-32-55.2-22.9-14.5-51.8-9.3-64.3-4.1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m519.1 469.8c22 12.3 50.7 5.9 60.2 1.6l-96.3-59.3c3 11.5 9.8 42.9 36.1 57.7zm-186.8 109.1c4.6-16.3 6.9-59.9-10-89.5-25.9-46.2-70.1-58-85.4-60.7z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m251.2 524.8c21.4 35.9 66.8 52.6 81 54.1l-95.2-150.2c-4.3 18.8-7.9 59.1 14.2 96.1z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m527.3 560.7c-2.3-16.9-17.6-59.5-45.2-80.5-42.6-32.5-88.9-26.1-104.2-22.6z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m428.4 542.4c35.4 25.6 86.2 22.5 98.9 18.4l-149.4-103.3c2.3 18.5 16.5 60.3 50.5 84.9z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m860.6 684.6c-12.1 28.8-10 53.7 5 55.1 14.7 1.3 35.9-21.7 47.2-50.3 10.8-27.9 8-50.8-6-52.1-14-1.3-34.6 19.5-46.2 47.3zm-69.8-208.2c-13.8 23.1-16 44.5-4.1 47.4 11.9 2.7 32.3-14.1 45.7-37.1 12.8-22.3 13.7-42.1 2.7-44.9-11-2.9-30.8 12.4-44.3 34.6zm-135.1 215.1c15.6-5.7 9.4-30.4-13.3-54.6-21.9-23.2-51.2-37-65.6-31.5-14.7 5.5-10 28.5 10.8 52 21.9 24.3 52.4 39.8 68.1 34.1z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m703.7 657.5c-54.5-76.4-66.9-102.8-138.2-163.5 16.4 30.3 277.2 376.6 34 195.6 0 0-139.7-96.8-322.7-86.7 0 0 356.2 37.7 418.9 277.4 0.4 2.2 1.2 14.5 1 18.4-2.5 32.3-13.6 59.4-23.1 77.1-7.9 14.7-22.7 33-27.2 37.8-22.5 23.7-62 32.7-77.3 39.7 17.5 12.4 75.6 1.9 101.7 0.1l97.2 4.2c2.8-0.2 12.3 0.5 17.2 0.5l15.5-43.8c0 0 43.1-8.8 59.9-11.8 16.5-3 35.2-4.9 35.2-4.9l-27.8 62c30.5 4 123.1 14.2 140 3.9-19.3-8-75.1-13.9-98-46.5-3.2-3.3-25.9-82.1-25.3-110.1l0.2-3.8c43.1-287.2 336.7-391 336.7-391-190 43.1-292.5 192.1-292.5 192.1-192.7 240.9-59-113.4-19.3-155.2-71.7 55.6-98 137.6-98 137.6 21.8-232.9 218.8-255.2 218.8-255.2-101.5-3-179.4 81.9-179.4 81.9-166.6 179.6-104.4-77.8-33.7-114.5-6.1 3.4-138 59.2-113.8 258.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaburWhite);
export default __webpack_public_path__ + "static/media/dabur-white.ba02c947a4e92a7e511ec558a2bfab3d.svg";
export { ForwardRef as ReactComponent };